/** A large, playful snowball that barrels downhill through the racers. */
export class SnowballEffect {
  private width: number;
  private height: number;
  private elapsedMs = 0;
  private active = false;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }

  begin() { this.elapsedMs = 0; this.active = true; }
  reset() { this.elapsedMs = 0; this.active = false; }
  update(dtMs: number) {
    if (this.active) this.elapsedMs += Math.max(0, Math.min(dtMs, 100));
  }

  getProgress() { return Math.min(1, this.elapsedMs / 1550); }

  draw(ctx: CanvasRenderingContext2D) {
    if (!this.active) return;
    const progress = this.getProgress();
    const travel = progress * progress * (3 - 2 * progress);
    const radius = Math.min(this.width * 0.31, 92 + progress * 118);
    const cx = this.width / 2 + Math.sin(progress * Math.PI * 2.2) * this.width * 0.045;
    const cy = -radius - 45 + travel * (this.height + radius * 2 + 110);
    const rotation = this.elapsedMs * 0.0085;

    ctx.save();

    // Powder wake left uphill of the rolling ball.
    const wake = ctx.createLinearGradient(0, Math.max(-20, cy - radius * 2.8), 0, cy);
    wake.addColorStop(0, 'rgba(224,241,250,0)');
    wake.addColorStop(0.55, 'rgba(224,241,250,0.34)');
    wake.addColorStop(1, 'rgba(250,253,255,0.80)');
    ctx.fillStyle = wake;
    ctx.beginPath();
    ctx.moveTo(cx - radius * 0.72, cy);
    ctx.lineTo(cx - radius * 0.34, cy - radius * 2.6);
    ctx.lineTo(cx + radius * 0.34, cy - radius * 2.6);
    ctx.lineTo(cx + radius * 0.72, cy);
    ctx.closePath();
    ctx.fill();

    // Loose chunks thrown out from the contact patch.
    for (let i = 0; i < 24; i++) {
      const side = i % 2 === 0 ? -1 : 1;
      const age = (progress * 1.8 + i * 0.137) % 1;
      const x = cx + side * (radius * (0.55 + age * 0.85));
      const y = cy + radius * 0.45 - age * 80 + Math.sin(i * 2.7) * 16;
      ctx.globalAlpha = (1 - age) * 0.72;
      ctx.fillStyle = i % 3 ? '#f8fcff' : '#c8dfed';
      ctx.beginPath();
      ctx.arc(x, y, 3 + (i % 5) * 1.3, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    ctx.shadowColor = 'rgba(54,91,119,0.45)';
    ctx.shadowBlur = 24;
    ctx.shadowOffsetY = 14;
    const ball = ctx.createRadialGradient(cx - radius * 0.30, cy - radius * 0.34, radius * 0.08, cx, cy, radius);
    ball.addColorStop(0, '#ffffff');
    ball.addColorStop(0.58, '#edf7fc');
    ball.addColorStop(0.86, '#c8e0ee');
    ball.addColorStop(1, '#9fbfd2');
    ctx.fillStyle = ball;
    ctx.beginPath();
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
    ctx.fill();

    // Rotating packed-snow seams make the sphere visibly roll.
    ctx.shadowBlur = 0;
    ctx.translate(cx, cy);
    ctx.rotate(rotation);
    ctx.strokeStyle = 'rgba(114,155,181,0.43)';
    ctx.lineWidth = Math.max(2, radius * 0.018);
    for (let i = -1; i <= 1; i++) {
      ctx.beginPath();
      ctx.ellipse(0, i * radius * 0.30, radius * 0.76, radius * 0.19, i * 0.72, 0, Math.PI * 2);
      ctx.stroke();
    }
    ctx.fillStyle = 'rgba(255,255,255,0.72)';
    ctx.beginPath();
    ctx.ellipse(-radius * 0.28, -radius * 0.35, radius * 0.18, radius * 0.10, -0.5, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  }
}
